import { AxiosResponse } from 'axios';
import { useEffect, useState } from 'react';
import { getCountries } from '../api';

let data: Promise<AxiosResponse<any>> | undefined;

export function getCountryStates(
  country: string,
  countries?: any[]
): { name: string; value: string }[] {
  return (
    countries?.find((el: any) => el.name === country)?.states || []
  ).map(({ name, cities }: any) => ({ name, value: name, cities }));
}

export function getStateCities(
  state: string,
  states?: any[]
): { name: string; value: string }[] {
  return (
    states?.find((el: any) => el.name === state)?.cities || []
  ).map(({ name }: any) => ({ name, value: name }));
}

function getDataOnce() {
  if (data) return data;

  data = getCountries().catch((err) => {
    data = undefined;
    throw err;
  });

  return data;
}

export default function useCountriesData() {
  const [data, setData] = useState<any[]>();
  const [isLoading, setIsLoading] = useState(Boolean(data));

  useEffect(() => {
    getDataOnce()
      .then((response) => setData(response.data.data))
      .finally(() => setIsLoading(false));
  }, []);

  return { data, isLoading };
}
